import axios from 'axios'
//import store from './store/store'
import router from './router/index'

// axios 配置
axios.defaults.timeout = 5000;
// 根据不同环境切换接口地址
const hostname = window.location.hostname
let baseApiHost = '';
if (hostname.indexOf('enochedu.cn') > -1) {
  baseApiHost = 'https://api.enochedu.cn';
} else if (hostname.indexOf('t1') > -1) {
  baseApiHost = 'https://ynjy-api.t1.test.noahgrouptest.com'
} else if (hostname.indexOf('t2') > -1) {
  baseApiHost = 'https://ynjy-api.t2.test.noahgrouptest.com'
} else if (hostname.indexOf('t3') > -1) {
  baseApiHost = 'https://ynjy-api.t3.test.noahgrouptest.com'
} else {
  baseApiHost = 'https://ynjy-api.t2.test.noahgrouptest.com';
}
axios.defaults.baseURL = baseApiHost;
const token=localStorage.getItem('token')
// http request 拦截器
axios.interceptors.request.use(
    config => {
        if(config.method === "put"){
          let qs = require('qs')
          config.data=qs.stringify(config.data)
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        }
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    });

// http response 拦截器
axios.interceptors.response.use(
    response => {
    	 return response;

    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 401 清除token信息并跳转到登录页面
                    store.commit(types.LOGOUT);
                    router.replace({
                        path: 'Home',
                        query: {redirect: router.currentRoute.fullPath}
                    })
            }
        }
          return Promise.reject(error.response.status)

        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402

    });

export default axios;



// WEBPACK FOOTER //
// ./src/http.js